/** Remove Google's root-path cookies before reloading the original document. */
export function clearGoogleTranslateCookies(doc: Document = document): void {
	const expire = (domain?: string) => {
		// biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API support is insufficient.
		doc.cookie = `googtrans=; Max-Age=0; path=/${domain ? `; domain=${domain}` : ""}`;
	};
	expire();
	// Google can set both host-only and domain cookies, including on a parent
	// domain. Deleting only the host-only cookie restores translation on reload.
	const labels = doc.location.hostname.split(".");
	for (let index = 0; index < labels.length - 1; index++) {
		expire(labels.slice(index).join("."));
	}
}
